import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Close, DirectionsBike } from "@mui/icons-material";
import BikeColor from "../BikeColor";
import { formatDate, formatTime } from "../../utils/dateFormat";
export default function GanchoDetailDialog({ gancho, onClose }) {
  const user = gancho?.usuario;
  const title = `Gancho #${String(gancho?.id || "").padStart(2, "0")}`;
  const fields = [
    ["Propietario", user?.nombre],
    ["Documento", user?.cedula],
    ["Celular", user?.celular],
    ["Serie", user?.serie],
    ["Ingreso", user?.entrada ? `${formatDate(user.entrada)} · ${formatTime(user.entrada)}` : null],
  ];
  return (
    <Dialog
      open={Boolean(gancho)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="bike-gancho-detail-title"
      PaperProps={{ sx: { borderRadius: 2.5, maxHeight: "90vh" } }}
    >
      <DialogTitle
        id="bike-gancho-detail-title"
        sx={{
          bgcolor: "#193e54",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          p: 2.5,
        }}
      >
        <DirectionsBike />
        <Box sx={{ flex: 1 }}>
          <Typography component="span" display="block" fontWeight={700} color="inherit">
            {title}
          </Typography>
          <Typography
            component="span"
            display="block"
            sx={{ fontSize: "0.8rem", color: "#dbe8f2" }}
          >
            Ocupado · Detalle de la bicicleta
          </Typography>
        </Box>
        <IconButton aria-label="Cerrar detalle del gancho" onClick={onClose} sx={{ color: "#fff" }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: "#f7f9fc", p: 2.5 }}>
        <Grid container spacing={2}>
          {fields.map(([label, value]) => (
            <Grid item xs={12} sm={6} key={label}>
              <Typography variant="caption" sx={{ color: "#526579" }}>
                {label}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#243b53", fontWeight: 600, overflowWrap: "anywhere" }}
              >
                {value || "Sin información"}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Box
          sx={{ mt: 2.5, p: 1.5, bgcolor: "#fff", border: "1px solid #dce5ed", borderRadius: 1.5 }}
        >
          <Typography variant="caption" display="block" sx={{ mb: 0.75, color: "#526579" }}>
            Color de la bicicleta
          </Typography>
          <BikeColor value={user?.color} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} sx={{ color: "#245a83", fontWeight: 600 }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
GanchoDetailDialog.propTypes = { gancho: PropTypes.object, onClose: PropTypes.func.isRequired };
